/**
 * @generated SignedSource<<eabb8d6ba9cdd9c1c71c813a79530103>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type VaultFieldInput_deleteVaultFieldValues_Mutation$variables = {
  valueIds: ReadonlyArray<string>;
  vaultId: string;
};
export type VaultFieldInput_deleteVaultFieldValues_Mutation$data = {
  readonly deleteVaultFieldValues: {
    readonly vault: {
      readonly fieldValues: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly id: string;
    };
  } | null;
};
export type VaultFieldInput_deleteVaultFieldValues_Mutation = {
  response: VaultFieldInput_deleteVaultFieldValues_Mutation$data;
  variables: VaultFieldInput_deleteVaultFieldValues_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "valueIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vaultId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "valueIds",
            "variableName": "valueIds"
          },
          {
            "kind": "Variable",
            "name": "vaultId",
            "variableName": "vaultId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "VaultsDeleteVaultFieldValuesMutationPayload",
    "kind": "LinkedField",
    "name": "deleteVaultFieldValues",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Vault",
        "kind": "LinkedField",
        "name": "vault",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "VaultFieldValue",
            "kind": "LinkedField",
            "name": "fieldValues",
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "VaultFieldInput_deleteVaultFieldValues_Mutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "VaultFieldInput_deleteVaultFieldValues_Mutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "56aed409b024298eea8b52fe9af58988",
    "id": null,
    "metadata": {},
    "name": "VaultFieldInput_deleteVaultFieldValues_Mutation",
    "operationKind": "mutation",
    "text": "mutation VaultFieldInput_deleteVaultFieldValues_Mutation(\n  $vaultId: ID!\n  $valueIds: [ID!]!\n) {\n  deleteVaultFieldValues(input: {vaultId: $vaultId, valueIds: $valueIds}) {\n    vault {\n      id\n      fieldValues {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "caae1b2bf2c969ad43be65a19ae6491f";

export default node;
